<template>
    <section id="consulting_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <nav aria-label="breadcrumb" class="mt-4 d-block d-lg-none">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'sports' }" class="text-reset">الإستشارات</router-link>
                        </li>
                    </ol>
                </nav>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <nav aria-label="breadcrumb" class="d-none d-lg-block">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <router-link :to="{ name: 'sports' }" class="text-reset">الإستشارات</router-link>
                                </li>
                            </ol>
                        </nav>

                        <p>تقديم الدعم الاستشاري والدراسات للمساهمة في رسم الخطط للمساهمة في اتخاذ القرارات المناسبة لتحقيق
                            الجودة والكفاءة.</p>

                        <h5 class="mt-3">أهمية الدعم الإستشاري للشركات</h5>

                        <p>لا تستغني الشركات بلا استثناء عن الاستشارات، والشركات الناشئة خاصة أشد حاجةً لذلك في بدايات
                            تأسيسها، كي تتلمس خُطاها، وتعرف أين تضع قدميها، وكيف تصنع لنفسها موقعًا على الخارطة السوقية
                            مبكرًا، وكيف تتقدم بخطىً ثابتة وواثقة متجنِّبةً الأخطاء والعثرات.</p>

                        <h5 class="mt-3">ماذا نستطيع أن نقدم لك؟</h5>

                        <p>قمنا بتقديم لرواد الأعمال، والشركات الناشئة، على حدٍ سواء، برنامجًا متكاملاً لكل منهما يقدم
                            الرعاية الكاملة والاهتمام الشامل والمتابعة الدائمة للمشروع الوليد من خلال مجموعة من العمليات
                            الفنية، ونماذج الأعمال التي تحميه من المخاطر المحتملة والممكنة، والتي تحيط به لتدفع به تدريجيًا
                            ليصبح قويا قادرًا على البقاء، والنماء، والاستمرار.</p>

                        <router-link :to="{ name: '' }" class="btn mt-3 mb-3 mb-lg-0" id="consult_btn">
                            طلب إستشارة
                        </router-link>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/services/consulting_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Consulting',
}
</script>

<style lang="scss" scoped>
#consulting_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            nav {
                .breadcrumb {

                    li:first-of-type {
                        font-size: 16px;
                        line-height: 180%;
                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    li:nth-of-type(2n) {
                        font-family: 'FFShamelFamily-Bold';
                        font-size: 18px;
                        line-height: 180%;
                        color: $Green;
                    }

                }

                .breadcrumb-item::before {
                    float: right;
                    margin-left: 8px;
                    background: $Linear-Blue;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Green;
                }

                h5:nth-of-type(2n) {
                    color: $Yellow;
                }

                #consult_btn {

                    width:fit-content;

                    padding: 6px 8px;

                    color: $White;
                    font-size: 16px;
                    line-height: 180%;

                    border-radius: 8px;

                    background: $Linear-Blue;
                    background-clip: padding-box;
                    -webkit-background-clip: padding-box;
                    -webkit-text-fill-color: $White;
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

    }

}
</style>